import { PermissionsEnum } from '@/auth/interfaces';
import {
  EstadosPreagendamientoEnumChoice,
  ROUTER_PATHS,
  useCheckPermissions,
  useLoaders,
} from '@/shared';
import { useGetPreagendamiento } from '@/shared/actions/erp';
import { AlertSeverityEnum } from '@/shared/interfaces';
import { useUiStore } from '@/store/ui';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import { SaveUpdatedPreagendaPyL } from '../../shared/components';

export interface SavePreagendamientoPyLProps { }


const ReviewPreagendaUpdatedPage: React.FC<
  SavePreagendamientoPyLProps
> = () => {
  useCheckPermissions(PermissionsEnum.api_change_preagendamiento);
  const setAlert = useUiStore(s => s.setAlert);

  const returnUrlAgendamientosPyLPage =
    ROUTER_PATHS.operaciones.agendamientoPyLNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetPreagendamiento(id!);
  useLoaders(isLoading || isRefetching);

  ///* effects ----------------
  // check state
  useEffect(() => {
    if (isLoading || isRefetching) return;

    if (
      !!data &&
      data?.data?.estado_preagendamiento !==
      EstadosPreagendamientoEnumChoice.PENDIENTE_REAGENDAR
    ) {
      setAlert(
        true,
        'La solicitud no se encuentra en estado correcto',
        AlertSeverityEnum.error
      );
    }
  }, [data, isLoading, isRefetching]);

  if (isLoading || isRefetching) return null;
  if (
    !data?.data?.id_preagendamiento ||
    data?.data?.estado_preagendamiento !==
    EstadosPreagendamientoEnumChoice.PENDIENTE_REAGENDAR
  )
    return <Navigate to={returnUrlAgendamientosPyLPage} />;

  return (
    <SaveUpdatedPreagendaPyL
      title="Revisar Preagendamiento"
      preagendamiento={data.data}
    />
  );
};

export default ReviewPreagendaUpdatedPage;
